"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitProfileFormStarted = exports.profileError = exports.receiveProfile = exports.receiveProfileStarted = exports.SUBMIT_PROFILE_FORM_STARTED = exports.PROFILE_ERROR = exports.RECEIVE_PROFILE = exports.RECEIVE_PROFILE_STARTED = void 0;
exports.default = reducer;
exports.loadProfile = loadProfile;
exports.submitProfileForm = submitProfileForm;
exports.submitProfileSettings = submitProfileSettings;
const validations_common_1 = require("components/form/validations-common");
const api_utils_1 = require("core/api-utils");
const redux_form_1 = require("redux-form");
const object_utils_1 = require("utils/object-utils");
// ducks
const app_1 = require("./app");
const contact_infos_1 = require("./contact-infos");
const api_1 = require("core/api");
const app_2 = require("selectors/app");
const contact_infos_2 = require("selectors/contact-infos");
// selectors
const profile_1 = require("selectors/profile");
const user_1 = require("selectors/user");
// Actions
exports.RECEIVE_PROFILE_STARTED = 'RECEIVE_PROFILE_STARTED';
exports.RECEIVE_PROFILE = 'RECEIVE_PROFILE';
exports.PROFILE_ERROR = 'PROFILE_ERROR';
exports.SUBMIT_PROFILE_FORM_STARTED = 'SUBMIT_PROFILE_FORM_STARTED';
// Reducer
const initialState = {
    currentProfile: {},
    profileLoaded: false,
};
function reducer(state = initialState, action = {}) {
    const profile = action.data;
    switch (action.type) {
        case 'RECEIVE_PROFILE_STARTED':
            return {
                ...state,
                profileLoaded: false,
            };
        case 'RECEIVE_PROFILE':
            return {
                ...state,
                profileLoaded: true,
                currentProfile: profile,
            };
        case 'PROFILE_ERROR':
            return {
                ...state,
                profileLoaded: false,
                error: action.error,
            };
        case 'SUBMIT_PROFILE_FORM_STARTED':
            return {
                ...state,
            };
        default:
            return state;
    }
}
// Action Creators
// singular since we are not getting more than one profile
const receiveProfileStarted = () => {
    return { type: exports.RECEIVE_PROFILE_STARTED };
};
exports.receiveProfileStarted = receiveProfileStarted;
const receiveProfile = (data) => {
    return { type: exports.RECEIVE_PROFILE, data };
};
exports.receiveProfile = receiveProfile;
const profileError = (data) => {
    return { type: exports.PROFILE_ERROR, data };
};
exports.profileError = profileError;
const submitProfileFormStarted = () => {
    return { type: exports.SUBMIT_PROFILE_FORM_STARTED };
};
exports.submitProfileFormStarted = submitProfileFormStarted;
// services
function loadProfile() {
    return (dispatch) => {
        dispatch((0, exports.receiveProfileStarted)());
        return api_1.PersonService.showProfile()
            .then((data) => {
            dispatch((0, exports.receiveProfile)(data));
        })
            .catch((error) => {
            dispatch((0, exports.profileError)(error));
        });
    };
}
//come back and figure out what force submit is doing in ProfileForm model submit
function submitProfileForm(data, _forceSubmit = false, hideFeedback = false, plainBirthdate = null) {
    const successText = 'Profile information has been updated';
    const errorText = 'Failed to update profile information';
    return (dispatch, getState) => {
        dispatch((0, exports.submitProfileFormStarted)());
        const isUCIenabled = (0, user_1.getIsUCIenabled)(getState()); // make more fields required if UCI is enabled
        // form validation lives here. We want it to be done after save has been clicked
        // but before the api calls go out.
        const formErrors = {
            profile: (0, validations_common_1.validateProfileData)(data, {
                birthdateRequired: isUCIenabled,
                genderRequired: isUCIenabled,
                plainBirthdate,
            }),
        };
        // if we're showing the save needed model, skip specific form errors and send them back to the working form
        if (!(0, app_2.showSaveNeeded)(getState())) {
            // we have to use deepEmpty here because formErrors has nested objects and we
            // want to check that those are empty
            if (!(0, object_utils_1.isDeepEmpty)(formErrors)) {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                throw new redux_form_1.SubmissionError(formErrors);
            }
        }
        if (!(0, profile_1.profileHasPerson)(getState())) {
            return api_1.PersonService.updateProfile({
                firstName: data.firstName,
                lastName: data.lastName,
                gender: data.gender || null,
                birthdate: data.birthdate || undefined,
                isAgeHidden: !!data.isAgeHidden,
            })
                .then((data) => {
                dispatch((0, exports.receiveProfile)(data));
                return dispatch((0, contact_infos_1.loadContactInfos)((0, profile_1.getPersonId)(getState()))).then((res2) => {
                    if (!hideFeedback) {
                        dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
                    }
                    return res2;
                });
            })
                .catch((errorRes) => {
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageError)(errorText));
                }
                if ((0, app_2.showSaveNeeded)(getState())) {
                    const rejectedPromise = new Promise((_resolve, reject) => {
                        // eslint-disable-line no-unused-vars
                        setTimeout(() => {
                            reject('profile form reject Save Needed');
                        }, 1000);
                    });
                    return rejectedPromise;
                }
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError({
                        profile: (0, api_utils_1.formatApiErrors)(errorRes.validationErrors),
                    });
                }
            });
        }
        else {
            return api_1.PersonService.updateProfile({
                firstName: data.firstName,
                lastName: data.lastName,
                gender: data.gender || null,
                birthdate: data.birthdate || undefined,
                isAgeHidden: !!data.isAgeHidden,
            })
                .then((data) => {
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
                }
                return dispatch((0, exports.receiveProfile)(data));
            })
                .catch((errorRes) => {
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageError)(errorText));
                }
                if ((0, app_2.showSaveNeeded)(getState())) {
                    const rejectedPromise = new Promise((_resolve, reject) => {
                        // eslint-disable-line no-unused-vars
                        setTimeout(() => {
                            reject('profile form reject Save Needed');
                        }, 1000);
                    });
                    return rejectedPromise;
                }
                if (errorRes.validationErrors) {
                    throw new redux_form_1.SubmissionError({
                        profile: (0, api_utils_1.formatApiErrors)(errorRes.validationErrors),
                    });
                }
            });
        }
    };
}
function submitProfileSettings(profileData, contactData, _forceSubmit = false, hideFeedback = false, plainBirthdate = null) {
    const successText = 'Profile information has been updated';
    const errorText = 'Failed to update profile information';
    return (dispatch, getState) => {
        // form validation lives here. We want it to be done after save has been clicked
        // but before the api calls go out.
        // if person has a userId, email is required, since strings are integers are
        // truth in js, isUser will return true if it exists
        const isUser = (0, user_1.getUserId)(getState());
        const isUCIenabled = (0, user_1.getIsUCIenabled)(getState()); // make more fields required if UCI is enabled
        const formErrors = (0, validations_common_1.validateProfileFormFields)(profileData, contactData, {
            emailRequired: isUCIenabled,
            birthdateRequired: isUCIenabled,
            phoneRequired: isUCIenabled,
            genderRequired: isUCIenabled,
            isUser,
            plainBirthdate,
            repeaterEmail: isUCIenabled,
            repeaterPhone: isUCIenabled,
        });
        // we have to use deepEmpty here because formErrors has nested objects and we
        // want to check that those are empty
        if (!(0, app_2.showSaveNeeded)(getState())) {
            if (!(0, object_utils_1.isDeepEmpty)(formErrors)) {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                throw new redux_form_1.SubmissionError(formErrors);
            }
        }
        return dispatch(submitProfileForm(profileData, false, true, plainBirthdate))
            .then(() => {
            // contactData will not have an ID if this is a user without a person_uuid
            // in that case, we want to get the contactInfos' id from state, not the
            // form data so the request to contact infos works properly.
            if (!contactData.id) {
                const primaryContact = (0, contact_infos_2.findPrimaryByPerson)((0, contact_infos_2.getContactInfos)(getState()), (0, profile_1.getPersonId)(getState()));
                if (primaryContact) {
                    contactData.id = primaryContact.id;
                }
            }
            const forceContactSubmit = contactData.id ? false : true;
            return dispatch((0, contact_infos_1.submitContactForm)((0, profile_1.currentProfileUuid)(getState()), contactData, forceContactSubmit, true))
                .then(() => {
                return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
            })
                .catch((_errorRes) => {
                if (!hideFeedback) {
                    dispatch((0, app_1.appFeedbackMessageError)(errorText));
                }
                const rejectedPromise = new Promise((_resolve, reject) => {
                    // eslint-disable-line no-unused-vars
                    setTimeout(() => {
                        reject('profile settings reject Save Needed');
                    }, 1000);
                });
                return rejectedPromise;
            });
        })
            .catch((errorRes) => {
            if (!hideFeedback) {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
            }
            if ((0, app_2.showSaveNeeded)(getState())) {
                const rejectedPromise = new Promise((_resolve, reject) => {
                    // eslint-disable-line no-unused-vars
                    setTimeout(() => {
                        reject('profile settings reject Save Needed');
                    }, 1000);
                });
                return rejectedPromise;
            }
            if (errorRes.errors) {
                throw new redux_form_1.SubmissionError(errorRes.errors);
            }
        });
    };
}
// base rejected Promise. This is used for the saveNeeded window. If a save button
// is clicked, it will wait to make sure the submit was successful. If it is not,
// we need to return a rejected promise so the saveNeeded window knows to trigger
// the onSaveError function
